import { Box, Typography } from "@mui/material";
import CartItemsComponent from "./cartItems";
import { CustomLeftIcon } from "../StyledComponents/StyledFields";

export const CartComponent = (props: any) => {
  return (
    <div style={{ width: "100%" }}>
      <div  style={{display: "flex", alignItems: "center", marginLeft:"20px"}}>
        <div onClick={props?.navigateBack} style={{ marginRight: "10px", display: "flex", alignItems: "center"}}>
          <CustomLeftIcon />
        </div>
        <Typography sx={{fontFamily: "Lato", fontSize: "28px", fontWeight: "bold", lineHeight: "140%"}}>List of Items Added</Typography>
      </div>
      <Box sx={{mx: "20px"}}>
        <CartItemsComponent navigateBack={props.navigateBack}/>
      </Box>
    </div>
  );
};